import { mapActions, mapGetters, mapMutations } from 'vuex';
import navigateTo from '../../../mixins/buy-flow';
import AdminBar from '@/components/admin-utils/admin-bar/index.vue';
import IconFacebook from '@/components/icons/IconFacebook.vue';
import IconInstagram from '@/components/icons/IconInstagram.vue';

//---
import { MEDIA } from '@/helpers/variables';
import HeaderNav from '@/components/@general/Header/HeaderNav/index.vue';
import HeaderMessage from '@/components/@general/Header/HeaderMessage/index.vue';
import HeaderTop from '@/components/@general/Header/HeaderTop/index.vue';
import HeaderSidebar from '@/components/@general/Header/HeaderSidebar/index.vue';
import IconClose from '@/components/icons/IconClose.vue';
import HeaderSearch from '@/components/@general/Header/HeaderSearch/index.vue';
import IconHeart from '@/components/icons/IconHeart.vue';
import HeaderBanner from '@/components/@general/Header/HeaderBanner/index.vue';
export default {
  name: 'Header',
  mixins: [navigateTo],

  components: {
    HeaderBanner,
    IconHeart,
    HeaderSearch,
    IconClose,
    HeaderSidebar,
    HeaderTop,
    HeaderMessage,
    HeaderNav,
    IconInstagram,
    IconFacebook,
    AdminBar
  },

  data() {
    return {
      MEDIA,
      openBurger: false,
      isShowSearch: false,
      headerMessages: []
    };
  },
  created() {
    this.fetchHeaderMenu();
    this.getHeaderBanner();
  },
  mounted() {
    this.getHeaderMessages().then((headerMessages) => {
      this.headerMessages = headerMessages;
      window.setInterval(() => {
        this.pollHeaders();
      }, 5000);
    });
  },
  watch: {
    $route() {
      this.openBurger = false;
    },
    openBurger() {
      if (this.openBurger === true) {
        document.getElementById('html').classList.add('hide');
      } else {
        document.getElementById('html').classList.remove('hide');
      }
    },
    isProfessional() {
      this.fetchHeaderMenu();
    }
  },

  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      basket: 'basket/basket',
      user: 'profile/user',
      isDistributor: 'profile/isDistributor',
      isManager: 'profile/isManager',
      isProfessional: 'profile/isProfessional',
      isUserWithCode: 'profile/isUserWithCode',
      headerMenu: 'setting/headerMenu',
      headerBanner: 'setting/headerBanner',
      whichList: 'favorites/whichList',
      contacts: 'setting/variables',
      appSize: 'app/size'
    })
  },
  methods: {
    ...mapMutations({
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP'
    }),
    ...mapActions({
      fetchHeaderMenu: 'setting/GET_HEADER_MENU',
      getHeaderMessages: 'setting/GET_HEADER_MESSAGES',
      getHeaderBanner: 'setting/GET_HEADER_BANNER'
    }),

    pollHeaders() {
      const first = this.headerMessages.shift();
      this.headerMessages = this.headerMessages.concat(first);
    },
    showPopup() {
      if (!this.isAuthenticated) {
        this.show = false;
        this.openBurger = false;
        this.changeLoginPopup(true);
      } else {
        this.navigateTo('profile');
      }
    },
    onToggleSearch(status) {
      this.isShowSearch = status;
    }
  }
};
